// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__h6aPR","footer_wrap":"Footer_footer_wrap__HLqkX","privacy":"Footer_privacy__LEpM6","logo":"Footer_logo__LMUDc","media":"Footer_media__tORwL"};